<aside class="container-nav">
  <section class="profile-section">
    <h2 class="customer-title">{{'sidebar.activeCustomer' | translate}}</h2>
    <div class="customer-dropdown">
      <mat-form-field appearance="outline" class="w-full">
        <mat-select [(ngModel)]="selectedCustomer.id" (ngModelChange)="onCustomerChange($event)">
          <mat-option *ngFor="let customer of customers" [value]="customer.id">
            {{customer.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <nav class="nav-menu">
      <a
        mat-ripple
        *flowHasPermission="[Permissions.ViewSmsAdmin]; disabled true; adminNav true;"
        routerLink="/sms"
        routerLinkActive="active"
        (click)="closeNav()"
        class="nav-item">
        {{'sidebar.sms' | translate}}
      </a>
      <a
        mat-ripple
        *flowHasPermission="[Permissions.ViewChannelAdmin]; disabled true; adminNav true;"
        routerLink="/channels"
        routerLinkActive="active"
        (click)="closeNav()"
        class="nav-item">
        {{'sidebar.channels' | translate}}
      </a>
      <a
        mat-ripple
        *flowHasPermission="[Permissions.ViewScreensAdmin]; disabled true; adminNav true;"
        routerLink="/devices"
        routerLinkActive="active"
        (click)="closeNav()"
        class="nav-item">
        {{'sidebar.devices' | translate}}
      </a>
      <a
        mat-ripple
        *ngIf="isAdmin && selectedCustomer?.id === -1"
        routerLink="/customers"
        routerLinkActive="active"
        (click)="closeNav()"
        class="nav-item">
        {{'sidebar.customers' | translate}}
      </a>
      <a
        mat-ripple
        *flowHasPermission="[Permissions.ViewClientsAdmin]; disabled true; adminNav true;"
        mat-list-item
        routerLink="/clients"
        routerLinkActive="active"
        (click)="closeNav()"
        class="nav-item">
        {{'sidebar.clients' | translate}}
      </a>
      <a
        mat-ripple
        *flowHasPermission="[Permissions.ViewContactPersonAdmin]; disabled true; adminNav true;"
        mat-list-item
        routerLink="/contact-persons"
        routerLinkActive="active"
        (click)="closeNav()"
        class="nav-item">
        {{'sidebar.contactPersons' | translate}}
      </a>
      <a
        mat-ripple
        *flowHasPermission="[Permissions.ViewUserPermissionsAdmin]; disabled true; adminNav true;"
        mat-list-item
        routerLink="/permissions"
        routerLinkActive="active"
        (click)="closeNav()"
        class="nav-item">
        {{'sidebar.permissions' | translate}}
      </a>
      <a
        mat-ripple
        *flowHasPermission="[Permissions.ViewUsersAdmin]; disabled true; adminNav true;"
        mat-list-item
        routerLink="/users"
        routerLinkActive="active"
        (click)="closeNav()"
        class="nav-item">
        {{'sidebar.users' | translate}}
      </a>
      <a class="nav-item cursor-pointer" (click)="openLanguageModal()">
        <span class="language-text justify-between">
          <span>{{'sidebar.language' | translate}}</span>
          <app-icon [ngStyle]="{cursor:'pointer'}" size="md" [iconName]="currentLanguage"></app-icon>
        </span>
      </a>
      <a *ngIf="isAdmin && selectedCustomer?.id === -1" routerLink="/settings" routerLinkActive="active" class="nav-item" (click)="closeNav()">
        {{'sidebar.settings' | translate}}
      </a>
      <a mat-ripple routerLink="/about" routerLinkActive="active" class="nav-item" (click)="closeNav()">
        {{'sidebar.about' | translate}}
      </a>
    </nav>
    <section class="settings">
      <hr class="divider-bottom" />
      <a type="button" class="logout-button" tabindex="0" (click)="logout()">{{'cogwheel.logOut' | translate}}</a>
    </section>
  </section>
</aside>
